import { CSSProperties } from "react";
import "./FeedbackOverview.css";
import { PrimaryButton } from "../../../../components/Modules/PrimaryButton";
import NormalInput from "./NormalInput";
import EmailInput from "./EmailInput";
import TextAreaInput from "./TextAreaInput";
import RatingInput from "./RatingInput";
import ImageInput from "./ImageInput";

export interface GeneralFeedbackContentStyleConfig {
    Form?: React.CSSProperties;
    Heading?: React.CSSProperties;
    Description?: React.CSSProperties;
    Input?: React.CSSProperties;
    Label?: React.CSSProperties;
    EmailError?: {
        text?: string,
        errorStyle?: React.CSSProperties
    },

    TopBar?: React.CSSProperties;
    TextArea?: React.CSSProperties;
    PrimaryButton?: React.CSSProperties;
    SecondaryButton?: React.CSSProperties;
    Modal?: React.CSSProperties;
    Footer?: React.CSSProperties;
    listHeading?: React.CSSProperties;
    listDescription?: React.CSSProperties;
    Card?: React.CSSProperties;
    Star?: {
        Style?: React.CSSProperties;
        PrimaryColor?: string;
        SecondaryColor?: string;
        Size?: number;
    }
    listHover?: {
        background?: string;
        iconBackground?: string;
        iconColor?: string;
        Heading?: string;
        Description?: string;
        IconSize?: string;
        Icon?: React.CSSProperties;
    };
    ThanksPopup?: {
        Style?: React.CSSProperties;
        Heading?: React.CSSProperties;
        Description?: React.CSSProperties;
        ShowFooter?: boolean;
        Icon?: React.CSSProperties;
    },
}
export interface GeneralFeedbackContentProps {
    starColor?: string;
    btnTextColor?: string;
    starBorderColor?: string;
    formdata: any;
    handleSubmit: () => void;
    handleUpdate: (e: any, id: string, j: string, k?: number) => void;
    answer: any;
    handleRemove?: (e: any) => void;
    ratingStyle?: "Star" | "Numbers" | "Smiles";
    labelStyle?: CSSProperties;
    iconColor?: string;
    buttonStyle?: CSSProperties;
    PrimaryButtonText?: string;
    StarStyle?: {
        Style?: React.CSSProperties;
        PrimaryColor?: string;
        SecondaryColor?: string;
        Size?: number;
    };
    isVisible: boolean | undefined;
    setIsVisible: Function | undefined;
    screenshot: FileProp | null | undefined;
    onStartCapture: () => void;
    setScreenshot: ((screenshot: FileProp | null) => void) | undefined;
    uploadFileToBackend: (file: any) => any;
    inputRef: React.MutableRefObject<HTMLInputElement | null>;
    file: FileProp | null;
    setFile: (file: FileProp | null) => any;
    styleConfig?: GeneralFeedbackContentStyleConfig,
    BrandTheme?: BrandTheme,
    QuestThemeData?: QuestThemeData,
    rating: number,
    setRating: (rating: number) => void
}

type BrandTheme = {
    accentColor?: string;
    background?: string;
    borderRadius?: string;
    buttonColor?: string;
    contentColor?: string;
    fontFamily?: string;
    logo?: string;
    primaryColor?: string;
    secondaryColor?: string;
    tertiaryColor?: string;
    titleColor?: string;
}

interface QuestThemeData {
    accentColor: string;
    theme: string;
    borderRadius: string;
    buttonColor: string;
    images: string[]
}

export interface FileProp {
    name: string;
    size: number;
    type: string;
    lastModified: number;
    webkitRelativePath: string;
}
const GeneralFeedbackContent: React.FC<GeneralFeedbackContentProps> = ({
    formdata,
    handleUpdate,
    handleSubmit,
    ratingStyle,
    answer,
    buttonStyle = {},
    labelStyle = {},
    PrimaryButtonText = "Submit",
    StarStyle,
    isVisible,
    setIsVisible,
    screenshot,
    setScreenshot,
    onStartCapture,
    uploadFileToBackend,
    inputRef,
    file,
    setFile,
    starBorderColor,
    rating,
    setRating
}) => {
    const handleRatingChange2 = (e: any, id: any, rating: number) => {
        setRating(rating);
        handleUpdate(e, id, "", rating);
    };

    const handleUploadImages = async (e: any) => {
        e.preventDefault();
        let urlArr = [];
        if (file !== null) {
            let url = await uploadFileToBackend(file);
            urlArr.push(url);
        }
        if (screenshot !== null) {
            let url = await uploadFileToBackend(screenshot);
            urlArr.push(url);
        }
        for (let i = 0; i < formdata.length; i++) {
            if (formdata[i].type === "USER_INPUT_IMAGE") {
                answer[formdata[i].criteriaId] = urlArr;
                break;
            }
        }
        handleSubmit();
        setFile(null);
        setScreenshot && setScreenshot(null);
    };

    return (
        <form className="q-fdov-ch-boxes" onSubmit={handleUploadImages}>
            {formdata?.length > 0 ? (
                <>
                    {formdata.map((data: any) => {
                        if (data.type === "USER_INPUT_TEXT") {
                            return <>
                                <NormalInput
                                    question={data.question || ""}
                                    criteriaId={data.criteriaId || ""}
                                    placeholder={data.placeholder || ""}
                                    required={data.required || false}
                                    answer={answer}
                                    handleUpdate={handleUpdate}
                                />
                            </>
                        } else if (data.type === "USER_INPUT_EMAIL") {
                            return <>
                                <EmailInput
                                    question={data.question || ""}
                                    criteriaId={data.criteriaId || ""}
                                    placeholder={data.placeholder || ""}
                                    required={data.required || false}
                                    answer={answer}
                                    handleUpdate={handleUpdate}
                                    feedbackType={"GeneralFeedback"}
                                />
                            </>
                        } else if (data.type === "USER_INPUT_TEXTAREA") {
                            return <>
                                <TextAreaInput
                                    question={data.question || ""}
                                    criteriaId={data.criteriaId || ""}
                                    placeholder={data.placeholder || ""}
                                    required={data.required || false}
                                    answer={answer}
                                    handleUpdate={handleUpdate}
                                    feedbackType={"GeneralFeedback"}
                                />
                            </>
                        } else if (data.type === "RATING") {
                            return <>
                                <RatingInput
                                    data={data}
                                    labelStyle={labelStyle}
                                    StarStyle={StarStyle}
                                    ratingStyle={ratingStyle}
                                    rating={rating}
                                    handleRatingChange2={handleRatingChange2}
                                    starBorderColor={starBorderColor}
                                />
                            </>
                        } else if (data.type === "USER_INPUT_IMAGE") {
                            return <>
                                <ImageInput
                                    screenshot={screenshot}
                                    setIsVisible={setIsVisible}
                                    isVisible={isVisible}
                                    onStartCapture={onStartCapture}
                                    file={file}
                                    inputRef={inputRef}
                                    setFile={setFile}
                                    setScreenshot={setScreenshot}
                                    feedbackType={"GeneralFeedback"}
                                />
                            </>
                        }
                    })}
                    <PrimaryButton
                        children={PrimaryButtonText}
                        style={buttonStyle}
                        className="q-fdov-btn-continue"
                        type="submit"
                    />
                </>
            ) : (
                <div className="q-center">No data Found</div>
            )}
        </form>
    );
};

export default GeneralFeedbackContent;
